
const lrftStore = {
    state: {
        spaces: [
          {
            name: 'The Factory',
            steward: 'Yatú Espinosa',
            address: '1660 E New York Ave, Brooklyn',
            phone: '‭(239) 877-9939‬',
            phoneTel: 'tel:+12398779939',
            googleMapsLink: 'https://goo.gl/maps/j956DSuEkzFcMESD6',
            visitingHours: 'Can visit 24/7',
          },
          {
            name: 'The Garage',
            steward: "Cyril (Nick) Engman",
            address: '1660 E New York Ave, Brooklyn',
            phone: '(214) 316-0638',
            phoneTel: 'tel:+12143160638',
            googleMapsLink: 'https://goo.gl/maps/j956DSuEkzFcMESD6',
            visitingHours: 'Can visit Wednesdays 10a-7p',
          },
          {
            name: 'Processa',
            steward: "Kam Robinson",
            address: '15-63 Decatur St, Ridgewood',
            phone: '(443) 960-2413',
            phoneTel: 'tel:+14439602413',
            googleMapsLink: 'https://goo.gl/maps/wcZPTjShm7ELpdBx7',
            socialLink: 'https://www.instagram.com/processa.art/',
            socialText: '@processa.art',
            visitingHours: 'Very Flexible, can reach out to schedule time',
          },
          {
            name: 'Quay',
            steward: "Sam Panter",
            address: '85 Quay St, Brooklyn',
            phone: '(602) 402-5065',
            phoneTel: 'tel:+16024025065',
            googleMapsLink: 'https://goo.gl/maps/Wbj1cYbiVEmoWLtc7',
            visitingHours: 'Can visit Weekdays 1-6p and inquire about Weekends',
          },
          {
            name: 'Eternal',
            steward: "Reggie James",
            address: '324 Grand St, New York',
            phone: '(917) 860-5419',
            phoneTel: 'tel:+19178605419',
            googleMapsLink: 'https://goo.gl/maps/1xS3YQHLQYMWWaZU8',
            socialLink: 'https://twitter.com/hiredbyeternal',
            socialText: '@hiredbyeternal',
            visitingHours: 'Can visit Weekdays 11a-6p',
          },
          {
            name: 'Daze',
            steward: "Willem Simons",
            address: '28 Marcy Ave',
            phone: '',
            phoneTel: 'tel:+1',
            // phone: '(908) 202-1907',
            // phoneTel: 'tel:+19082021907',
            googleMapsLink: 'https://goo.gl/maps/mFALUic4LWwHxUGL9',
            socialText: '@daze.nyc',
            socialLink: 'https://www.instagram.com/daze.nyc/',
          },
          {
            name: 'The Playground',
            steward: "Yatú Espinosa",
            address: '102 Somers St #4B, Brooklyn',
            phone: '‭(239) 877-9939‬',
            phoneTel: 'tel:+12398779939',
            googleMapsLink: 'https://goo.gl/maps/erRfscYXCEhDZ7iCA',
            visitingHours: 'Can visit 12-3p',
          },
        ],
        encouragers: [
          {
            name: 'Sean',
            phone: '(626) 703-6062‬',
            phoneTel: 'tel:+17036062‬',
            what: 'Project Design Support'
          },
          {
            name: 'Aaron',
            phone: '‭ (224) 234-1067‬',
            phoneTel: 'tel:+12242341067‬',
            what: 'Encouragement and Learning Support'
          },
          {
            name: 'Norm',
            phone: '‭(248) 872-3388‬',
            phoneTel: 'tel:+12488723388',
            what: 'Encouragement and Learning Support'
          },
        ],
    },
    getters: {
    },
    actions: {
      // scrollToConcept(context, id){
      //   context.commit('setScrollToConceptId', { id });
      // },
    },
    mutations: {
      // setScrollToConceptId(state, { id }){
      //   state.concepts.scrollToConceptId = id;
      // },
    },
}
export default lrftStore;
